import { Col, Flex, Row } from 'antd';

// Constants
import { FC } from 'react';
import { ROUTES } from '../../../constants/routes-constants';
import { Link } from 'react-router-dom';

interface AuthLayoutProps {
  large?: boolean;
  children: React.ReactNode;
}

export const AuthLayout: FC<AuthLayoutProps> = (props) => {
  return (
    <div>
      <Row>
        <Col span={0} md={props.large ? 8 : 12} lg={props.large ? 12 : 16}>
          <img
            alt="background"
            src={`${process.env.PUBLIC_URL}/login.jpg`}
            style={{ width: '100%', height: '100vh', objectFit: 'cover' }}
          />
        </Col>

        <Col span={24} md={props.large ? 16 : 12} lg={props.large ? 12 : 8}>
          <Flex align="center" vertical justify="space-evenly" style={{ height: '100vh' }}>
            <div>
              <Link to={ROUTES.HOMEPAGE_ROUTE}>
                <div className="login-page-subtitle">
                  <img
                    className="login-page-footer-logo"
                    src={`${process.env.PUBLIC_URL}/logo_gba.png`}
                  />
                </div>
              </Link>
            </div>

            <div
              className="login-form-container"
              style={{ minWidth: 325, maxWidth: props.large ? '80%' : 325, overflow: 'scroll' }}
            >
              {props.children}
            </div>
          </Flex>
        </Col>
      </Row>
    </div>
  );
};
